import { createStructuredSelector } from "reselect";
import {
    ORP_COMPRAS_UNOPS,
    ORP_COMPRAS_UNOPS_SUCCESS,
    ORP_COMPRAS_UNOPS_ERROR,
    ORP_COMPRAS_UNOPS_SET,
    ORP_COMPRAS_UNOPS_PAGE_SET,
    ORP_COMPRAS_UNOPS_SEARCH_CHANGE
} from "../actions";

export const NAME = 'orpcompras';


export const OrpComprasUnops = ( filters, stateFilter) => ({
    type: ORP_COMPRAS_UNOPS,
    payload: {  filters: filters, filtersState: stateFilter }
});

export const OrpComprasUnopsSuccess = (data) => ({
    type: ORP_COMPRAS_UNOPS_SUCCESS,
    payload: data
});

export const OrpComprasUnopsError = (error) => ({
    type: ORP_COMPRAS_UNOPS_ERROR,
    payload: error
});

export const OrpComprasUnopsSet = (data) => ({
    type: ORP_COMPRAS_UNOPS_SET,
    payload: data
});

export const OrpComprasUnopsPageSet = (data) => ({
    type: ORP_COMPRAS_UNOPS_PAGE_SET,
    payload: data
});

export const OrpComprasUnopsChangeSet = (data) => ({
    type: ORP_COMPRAS_UNOPS_SEARCH_CHANGE,
    payload: data
});


const orpcompras = (state) => state[NAME];

export const OrpComprasSelector = createStructuredSelector({
    orpcompras
})
